define([
  "i18n/i18n",
  "client/template",
  "client/views/list",
  "component!base",
  "underscore",
  "component!mustache",
  "api/v2/common",
  "utils/mustache",
], function (
  i18n,
  Template,
  ListView,
  Base,
  _,
  MustacheTemplate,
  Common,
  MustacheAdapter
) {

  var SearchSettings = MustacheTemplate.View.extend({

    initialize: function () {
      this.options.template = { mustacheAdapter: new MustacheAdapter(this.constructor.DEFAULT_TEMPLATE) };
      MustacheTemplate.View.prototype.initialize.apply(this, arguments);
    },

    change: function () {
      this.render();
      this.reloadSearch();
    },

    render: function () {
      MustacheTemplate.View.prototype.render.apply(this, arguments);
      i18n.patchI18nAttributes(this.$el);
    },

    reloadSearch: function () {
      var search = this.options.application.models.search;
      search.set(search.input.get());
    }

  });

  SearchSettings.DEFAULT_TEMPLATE = '\
  <div class="checkbox">\
    <input type="checkbox" data-name="checked" class="action" {{#checked?}}checked{{/checked?}} id="{{key}}">\
    <h4>\
      <label for="{{key}}">\
        <span data-i18n="{{label}}"></span>\
      </label>\
    </h4>\
  </div>';

  var SearchSettingsTemplate = Template.extend({

    model: function () {
      return this.application.models.searchSettings;
    }

  });

  SearchSettingsTemplate.View = ListView.extend({

    initialize: function () {
      this.options.childViewConstructor = SearchSettings;
      this.options.entryTagName = "li";
      this.options.entryClassName = "";

      ListView.prototype.initialize.apply(this, arguments);
    }

  });

  return SearchSettingsTemplate;

});
